import { GiftNotesService } from '@services/giftNotes'
import { store } from '@/store'
import LoadingPromiseUtil from '@utils/loadingPromise'

export default {
  namespaced: true,
  state: {
    giftNoteData: {
      title: '',
      file: null // prepopulate name like this { name: nameOfFile }
    },
    imageId: null,
    loadingPromiseUtil: new LoadingPromiseUtil()
  },
  mutations: {
    setGiftNoteData (state, Data) {
      state.giftNoteData = { ...Data }
    },
    setImageId (state, Id) {
      state.imageId = Id
    }
  },
  actions: {
    async setCustomerPreference (context, value) {
      GiftNotesService.setCustomerPreference(value)
    },
    async setCustomerPreferenceValue (context, value) {
      GiftNotesService.setCustomerPreferenceValue(value)
    },
    async getGiftNoteTemplate () {
      const user = store.getters['user/getUser']
      const id = user.impersonatedUserId || user.id
      const logo = await GiftNotesService.getGiftNoteTemplate(id)
      let file = new File([], logo.fileName)
      return file
    },
    async getRecentGiftNotes () {
      return await GiftNotesService.getRecentGiftNotes()
    },
    setGiftNoteData ({ commit }, Data) {
      commit('setGiftNoteData', Data)
    },
    setImageId ({commit}, Id) {
      commit('setImageId', Id)
    },
    async uploadGiftNoteImage (imageData) {
      var logoSentIn = imageData.getters.giftNoteData.file
      let fileType
      switch (logoSentIn.type) {
        case 'image/jpeg':
          fileType = 6
          break
        case 'image/png':
          fileType = 10
          break
        case 'application/pdf':
          fileType = 2
          break
        default:
          fileType = 6
          break
      }
      //  this will return the image location id in the form of a URL from the attachments
      const imageId = await GiftNotesService.uploadImageAttachment(logoSentIn.name, fileType, imageData)
      var lastSlash = imageId.AttachmentUri.lastIndexOf('/')
      let imageLocationId = imageId.AttachmentUri.substring(lastSlash + 1)
      const user = store.getters['user/getUser']
      const id = user.impersonatedUserId || user.id
      await GiftNotesService.setCustomerPreferenceValue(id, imageLocationId)
    }
  },
  getters: {
    giftNoteData: state => state.giftNoteData,
    imageId: state => state.imageId,
    loading: state => scope => state.loadingPromiseUtil.isLoading(scope)
  }
}
